import { StandardInput } from "components/forms/input";
import { useBasket } from "lib/hooks/basket/use-basket";
import { useInput } from "lib/hooks/use-input";
import { useUser } from "lib/hooks/use-user";

export const AddressSection = () => {
  const { userData } = useUser();
  const [basket, modifyBasket] = useBasket();
  const name = useInput<string>("");
  const email = useInput<string>(userData?.email || "");
  const phone_number = useInput<string>("");
  const line1 = useInput<string>("");
  const line2 = useInput<string>("");
  const line3 = useInput<string>("");
  const region = useInput<string>("");
  const city = useInput<string>("");
  const code = useInput<string>("");

  return (
    <>
      <p className='text-sm italic col-span-full pl-7'>
        If you choose to pick up in store, you only need to fill out your name,
        contact email, and country.
      </p>
      <StandardInput
        label='Name'
        id='name'
        type='text'
        inputProps={{ required: true }}
        bind={{
          onChange: (v) => {
            modifyBasket({
              type: "set-address",
              payload: {
                ...basket.address,
                name: v.target.value,
              },
            });
          },
          value: basket.address?.name || "",
        }}
        className='col-span-full'
      />
      <StandardInput
        label='Contact Email'
        id='email'
        name='email'
        type='email'
        inputProps={{ required: true, autoComplete: "email" }}
        bind={{
          onChange: (v) => {
            modifyBasket({
              type: "set-address",
              payload: {
                ...basket.address,
                contact_email: v.target.value,
              },
            });
          },
          value: basket.address?.contact_email || "",
        }}
        className='col-span-full'
      />
      <StandardInput
        label='Contact Number'
        id='number'
        name='number'
        type='phone'
        inputProps={{ required: true, autoComplete: "phone" }}
        bind={{
          onChange: (v) => {
            modifyBasket({
              type: "set-address",
              payload: {
                ...basket.address,
                phone_number: v.target.value,
              },
            });
          },
          value: basket.address?.phone_number || "",
        }}
        className='col-span-full'
      />
      <StandardInput
        label='Line 1'
        id='line1'
        type='text'
        inputProps={{ required: true, autoComplete: "address-line1" }}
        bind={{
          onChange: (v) => {
            modifyBasket({
              type: "set-address",
              payload: {
                ...basket.address,
                line_1: v.target.value,
              },
            });
          },
          value: basket.address?.line_1 || "",
        }}
        className='col-span-full'
      />
      <StandardInput
        label='Line 2 (optional)'
        id='line2'
        type='text'
        inputProps={{ autoComplete: "address-line2" }}
        bind={{
          onChange: (v) => {
            modifyBasket({
              type: "set-address",
              payload: {
                ...basket.address,
                line_2: v.target.value,
              },
            });
          },
          value: basket.address?.line_2 || "",
        }}
      />
      <StandardInput
        label='Line 3 (optional)'
        id='line3'
        type='text'
        inputProps={{ autoComplete: "address-line3" }}
        bind={{
          onChange: (v) => {
            modifyBasket({
              type: "set-address",
              payload: {
                ...basket.address,
                line_3: v.target.value,
              },
            });
          },
          value: basket.address?.line_3 || "",
        }}
      />

      <StandardInput
        label='Region (optional)'
        id='region'
        type='text'
        bind={{
          onChange: (v) => {
            modifyBasket({
              type: "set-address",
              payload: {
                ...basket.address,
                region: v.target.value,
              },
            });
          },
          value: basket.address?.region || "",
        }}
      />
      <div className='hidden xl:block xl:col-span-1'></div>
      <StandardInput
        label='City'
        id='city'
        type='text'
        inputProps={{ required: true }}
        bind={{
          onChange: (v) => {
            modifyBasket({
              type: "set-address",
              payload: {
                ...basket.address,
                city: v.target.value,
              },
            });
          },
          value: basket.address?.city || "",
        }}
      />
      <StandardInput
        label='Post Code'
        id='code'
        type='text'
        inputProps={{ required: true }}
        bind={{
          onChange: (v) => {
            modifyBasket({
              type: "set-address",
              payload: {
                ...basket.address,
                code: v.target.value,
              },
            });
          },
          value: basket.address?.code || "",
        }}
      />
    </>
  );
};
